import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';

import CustomTable from '../../../components/CustomTable';

const REGISTRADO = 1;
const ANULADO = 2;
const EMITIDO = 4;
const RECHAZADO = 5;

export default function ResultList(props) {
    const renderColor = (item) => {
        if (item.idGuiaRemisionEstado === REGISTRADO)
            return 'blue';
        if (item.idGuiaRemisionEstado === EMITIDO)
            return 'green';
        if (item.idGuiaRemisionEstado === RECHAZADO)
            return 'orange';
        if (item.idGuiaRemisionEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.rowNumber}
            columns={[

                {
                    title: 'Serie',
                    dataIndex: 'serie',
                    key: 'serie',
                    sorter: true
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha Emisión',
                    dataIndex: 'fechaEmision',
                    key: 'fechaEmision',
                    sorter: true
                },
                {
                    title: 'Fecha Traslado',
                    dataIndex: 'fechaTraslado',
                    key: 'fechaTraslado',
                    sorter: true
                },

                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoEntidad',
                    key: 'tipoDocumentoEntidad',
                    sorter: true
                },
                {
                    title: 'Número de Documento',
                    dataIndex: 'numeroDocumento',
                    key: 'numeroDocumento',
                    sorter: true
                },
                {
                    title: 'Entidad',
                    dataIndex: 'razonSocial',
                    key: 'razonSocial',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Numero Destinatario',
                    dataIndex: 'numeroDestinatario',
                    key: 'numeroDestinatario',
                    sorter: true
                },
                {
                    title: 'Nombre Destinatario',
                    dataIndex: 'nombreDestinatario',
                    key: 'nombreDestinatario',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "250px" }}>{value}</div>
                    )
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'proyecto',
                    key: 'proyecto',
                    sorter: true
                },
                {
                    title: 'Motivo',
                    dataIndex: 'motivo',
                    key: 'motivo',
                    sorter: true
                },
                {
                    title: 'Tipo Traslado',
                    dataIndex: 'tipoTraslado',
                    key: 'tipoTraslado',
                    sorter: true
                },



                {
                    title: 'Producto',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Cod. Referencia',
                    dataIndex: 'codigoReferencia',
                    key: 'codigoReferencia',
                    sorter: true
                },
                {
                    title: 'Codigo Sunat',
                    dataIndex: 'codigoSunat',
                    key: 'codigoSunat',
                    sorter: true
                },
                {
                    title: 'Arancelaria',
                    dataIndex: 'arancelaria',
                    key: 'codigoSunat',
                    sorter: true
                },
                {
                    title: 'Codigo DAM/DS',
                    dataIndex: 'codigoDam',
                    key: 'codigoDam',
                    sorter: true
                },
                {
                    title: 'Normalizado',
                    dataIndex: 'normalizado',
                    key: 'normalizado',
                    sorter: true,
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={value == "SI" ? "green" : "red"}>{value}</Tag>
                        </div>)
                    }
                },
                {
                    title: 'Unidad Medida',
                    dataIndex: 'unidadMedida',
                    key: 'unidadMedida',
                    sorter: true
                },
                {
                    title: 'Cantidad',
                    dataIndex: 'cantidad',
                    key: 'cantidad',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Peso Unitario',
                    dataIndex: 'pesoUnitario',
                    key: 'pesoUnitario',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Total Peso',
                    dataIndex: 'totalPeso',
                    key: 'totalPeso',
                    sorter: true,
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(2))}</span>
                    )
                },
                {
                    title: 'Estado',
                    dataIndex: 'estadoGuia',
                    key: 'estadoGuia',
                    align: 'center',
                    width: "90px",
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                },
                {
                    title: 'Numero MTC',
                    dataIndex: 'numeroMTC',
                    key: 'numeroMTC',
                    sorter: true
                },
                {
                    title: 'Tipo Doc Transportista',
                    dataIndex: 'tipoDocTransportista',
                    key: 'tipoDocTransportista',
                    sorter: true
                },

                {
                    title: 'Número de Transportista',
                    dataIndex: 'numeroTransportista',
                    key: 'numeroTransportista',
                    sorter: true
                },
                {
                    title: 'Nombre Transportista',
                    dataIndex: 'nombreTransportista',
                    key: 'nombreTransportista',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Ubigeo Llegada',
                    dataIndex: 'ubigeoLlegada',
                    key: 'ubigeoLlegada',
                    sorter: true
                },
                {
                    title: 'Direccion Llegada',
                    dataIndex: 'direccionLlegada',
                    key: 'direccionLlegada',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "250px" }}>{value}</div>
                    )
                },
                {
                    title: 'Numero Bultos',
                    dataIndex: 'numeroBultos',
                    key: 'numeroBultos',
                    sorter: true
                },
                {
                    title: 'Ubigeo Partida',
                    dataIndex: 'ubigeoPartida',
                    key: 'ubigeoPartida',
                    sorter: true
                },
                {
                    title: 'Direccion Partida',
                    dataIndex: 'direccionPartida',
                    key: 'direccionPartida',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "250px" }}>{value}</div>
                    )
                },

                {
                    title: 'Usuario',
                    dataIndex: 'usuario',
                    key: 'usuario',
                    sorter: true
                },
                {
                    title: 'Fecha Emision Sunat',
                    dataIndex: 'fechaEmisionSunat',
                    key: 'fechaEmisionSunat',
                    sorter: true
                },
                {
                    title: 'Documento Referencias',
                    dataIndex: 'docReferencias',
                    key: 'docReferencias',
                    sorter: true
                },
                {
                    title: 'Placa Pricipal',
                    dataIndex: 'placaPricipal',
                    key: 'placaPricipal',
                    sorter: true
                },
                {
                    title: 'Tuce Pricipal',
                    dataIndex: 'tucePricipal',
                    key: 'tucePricipal',
                    sorter: true
                },

                {
                    title: 'Placa Secundario',
                    dataIndex: 'placaSecun',
                    key: 'placaSecun',
                    sorter: true
                },
                {
                    title: 'Tuce Secundario',
                    dataIndex: 'tuceSecun',
                    key: 'tuceSecun',
                    sorter: true
                },
                {
                    title: 'Número Licencia',
                    dataIndex: 'numeroLicencia',
                    key: 'numeroLicencia',
                    sorter: true
                },
                {
                    title: 'Número Conductor',
                    dataIndex: 'numeroConductor',
                    key: 'numeroConductor',
                    sorter: true
                },
                {
                    title: 'Nombre Conductor',
                    dataIndex: 'nombreConductor',
                    key: 'nombreConductor',
                    sorter: true,
                    render: (value) => (
                        <div style={{ minWidth: "150px" }}>{value}</div>
                    )
                },
                {
                    title: 'Observacion',
                    dataIndex: 'observacion',
                    key: 'observacion',
                    sorter: true
                }
            ]}
        />
    );

}
